import { lazyNamed } from 'src/utils/lazyNamed';

export const PartnerFilialManagement = {
  PartnerBranches: lazyNamed(() => import('./containers'), 'PartnerBranches'),
};
